const menuActionsFactory = (CatalogService, Dispatcher, StoreStates, StorageService) => {
  'ngInject';

  const actions = {
    getMenus: () => {
      Dispatcher.dispatch({
        actionType: 'MENU_LOAD_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.getMenus().then(menus => Dispatcher.dispatch({
        actionType: 'MENU_LOAD',
        data: {
          menus
        },
        state: StoreStates.STORE_VALID
      }), reason => Dispatcher.dispatch({
        actionType: 'MENU_LOAD_FAIL',
        data: {
          reason
        },
        state: StoreStates.STORE_FAILED_UPDATE
      }));
    },
    createMenu: menu => {
      Dispatcher.dispatch({
        actionType: 'SAVEMENU_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
      CatalogService.createMenu(menu, merchantProfile.business.id).then(createdMenu => Dispatcher.dispatch({
        actionType: 'SAVEMENU_CREATED',
        data: {
          menu: createdMenu
        },
        state: "RELOAD"
      }), reason => Dispatcher.dispatch({
        actionType: 'SAVEMENU_FAIL',
        data: {
          reason
        },
        state: StoreStates.STORE_VALID
      }));
    },
    deleteMenu: menuId => {
      Dispatcher.dispatch({
        actionType: 'SAVEMENU_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
      CatalogService.deleteMenu(menuId, merchantProfile.business.id).then(() => Dispatcher.dispatch({
        actionType: 'SAVEMENU_DELETED',
        data: {
          menuId
        },
        state: StoreStates.STORE_VALID
      }), reason => Dispatcher.dispatch({
        actionType: 'SAVEMENU_FAIL',
        data: {
          reason
        },
        state: StoreStates.STORE_VALID
      }));
    },
    editMenu: (menu, menuId) => {
      var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
      Dispatcher.dispatch({
        actionType: 'SAVEMENU_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.editMenu(menu, menuId, merchantProfile.business.id).then(() => Dispatcher.dispatch({
        actionType: 'SAVEMENU_EDIT',
        data: {
          menu,
          menuId
        },
        state: StoreStates.STORE_VALID
      }), reason => Dispatcher.dispatch({
        actionType: 'SAVEMENU_FAIL',
        data: {
          reason
        },
        state: StoreStates.STORE_VALID
      }));
    },
    setMenuProducts: (menuId, productIds) => {
      Dispatcher.dispatch({
        actionType: 'SAVEMENU_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.setMenuProducts(menuId, productIds).then(() => {
        Dispatcher.dispatch({
          actionType: 'SAVEMENU_PRODUCTS_ASSIGNED',
          data: {
            menuId,
            productIds
          },
          state: StoreStates.STORE_VALID
        });
      }, reason => Dispatcher.dispatch({
        actionType: 'SAVEMENU_FAIL',
        data: {
          reason
        },
        state: StoreStates.STORE_VALID
      }));
    },
    addProductToMenu: (menuId, productId) => {
      Dispatcher.dispatch({
        actionType: 'SAVEMENU_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.addProductToMenu(menuId, productId).then(() => Dispatcher.dispatch({
        actionType: 'SAVEMENU_PRODUCT_ADDED',
        data: {
          menuId,
          productId
        },
        state: StoreStates.STORE_VALID
      }), reason => Dispatcher.dispatch({
        actionType: 'SAVEMENU_FAIL',
        data: {
          reason
        },
        state: StoreStates.STORE_VALID
      }));
    },
    removeProductFromMenu: (menuId, productId) => {
      Dispatcher.dispatch({
        actionType: 'SAVEMENU_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.removeProductFromMenu(menuId, productId).then(() => Dispatcher.dispatch({
        actionType: 'SAVEMENU_PRODUCT_DELETED',
        data: {
          menuId,
          productId
        },
        state: StoreStates.STORE_VALID
      }), reason => Dispatcher.dispatch({
        actionType: 'SAVEMENU_FAIL',
        data: {
          reason
        },
        state: StoreStates.STORE_VALID
      }));
    },
    enableMenu: menuId => {
      Dispatcher.dispatch({
        actionType: 'SAVEMENU_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.enableMenu(menuId).then(() => Dispatcher.dispatch({
        actionType: 'SAVEMENU_ENABLED',
        data: {
          menuId
        },
        state: StoreStates.STORE_VALID
      }), reason => Dispatcher.dispatch({
        actionType: 'SAVEMENU_FAIL',
        data: {
          reason
        },
        state: StoreStates.STORE_VALID
      }));
    },
    disableMenu: menuId => {
      Dispatcher.dispatch({
        actionType: 'SAVEMENU_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.disableMenu(menuId).then(() => Dispatcher.dispatch({
        actionType: 'SAVEMENU_DISABLED',
        data: {
          menuId
        },
        state: StoreStates.STORE_VALID
      }), reason => Dispatcher.dispatch({
        actionType: 'SAVEMENU_FAIL',
        data: {
          reason
        },
        state: StoreStates.STORE_VALID
      }));
    }
  };

  return actions;
};

export default menuActionsFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/actions/menu.actions.factory.js
 **/